import numeral from "numeral"

export default {
    methods: {
        currency(val) {
            return numeral(val).format(",3.00")
        },
    },
}
